export default __webpack_public_path__ + "static/media/industry-solid.16374f12.svg";